(() => {
  const SECTION_SELECTOR = '.oddit-section-faq';
  const DESKTOP_QUERY = window.matchMedia('(min-width: 990px)');
  const COLLAPSED_MOBILE_CLASS = 'oddit-section-faq__container--collapsed-mobile';
  const COLLAPSED_DESKTOP_CLASS = 'oddit-section-faq__container--collapsed-desktop';
  const COLLAPSED_CLASS = 'oddit-section-faq__container--collapsed';

  function initSection(section) {
    const triggers = section.querySelectorAll('[data-faq-trigger]');
    for (const trigger of triggers) {
      trigger.addEventListener('click', handleToggle);
    }
    const sectionTrigger = section.querySelector('[data-faq-section-trigger]');
    if (sectionTrigger) {
      sectionTrigger.addEventListener('click', handleSectionToggle);
      syncDefaultState(sectionTrigger);
    }
  }

  function isDefaultCollapsed(container) {
    return container.classList.contains(DESKTOP_QUERY.matches ? COLLAPSED_DESKTOP_CLASS : COLLAPSED_MOBILE_CLASS);
  }

  function setSectionState(button, isOpen) {
    const icon = button.querySelector('.oddit-section-faq__icon');
    button.setAttribute('aria-expanded', String(isOpen));
    icon.classList.toggle('oddit-section-faq__icon--active', isOpen);
  }

  function syncDefaultState(button) {
    const container = button.closest('[data-faq-container]');
    if (container.dataset.faqToggled) return;
    setSectionState(button, !isDefaultCollapsed(container));
  }

  function handleSectionToggle(e) {
    const button = e.currentTarget;
    const container = button.closest('[data-faq-container]');
    const list = container.querySelector('[data-faq-list]');
    const isOpen = button.getAttribute('aria-expanded') === 'true';

    container.dataset.faqToggled = 'true';
    container.classList.remove(COLLAPSED_MOBILE_CLASS, COLLAPSED_DESKTOP_CLASS);
    container.classList.toggle(COLLAPSED_CLASS, isOpen);
    list.hidden = isOpen;
    setSectionState(button, !isOpen);
  }

  function handleBreakpointChange() {
    document.querySelectorAll(`${SECTION_SELECTOR} [data-faq-section-trigger]`).forEach(syncDefaultState);
  }

  function handleToggle(e) {
    const button = e.currentTarget;
    const item = button.closest('[data-faq-item]');
    const answer = item.querySelector('[data-faq-answer]');
    const icon = button.querySelector('.oddit-section-faq__icon');
    const isOpen = button.getAttribute('aria-expanded') === 'true';

    button.setAttribute('aria-expanded', String(!isOpen));
    answer.setAttribute('aria-hidden', String(isOpen));

    if (isOpen) {
      answer.hidden = true;
      icon.classList.remove('oddit-section-faq__icon--active');
    } else {
      answer.hidden = false;
      icon.classList.add('oddit-section-faq__icon--active');
    }
  }

  function destroySection(section) {
    const triggers = section.querySelectorAll('[data-faq-trigger]');
    for (const trigger of triggers) {
      trigger.removeEventListener('click', handleToggle);
    }
    const sectionTrigger = section.querySelector('[data-faq-section-trigger]');
    if (sectionTrigger) sectionTrigger.removeEventListener('click', handleSectionToggle);
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  DESKTOP_QUERY.addEventListener('change', handleBreakpointChange);

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();